import React from 'react'

import { InputLabeledWrapper } from './styles'
import { IProps } from './types'

function InputLabeled({ id, label, error, className, ...rest }: IProps) {
	const errorId = `${id}-error`

	return (
		<InputLabeledWrapper className={className} $hasError={!!error}>
			<label htmlFor={id}>{label}</label>
			<input
				id={id}
				aria-invalid={!!error}
				aria-describedby={error ? errorId : undefined}
				{...rest}
			/>
			{!!error && (
				<span className='error' id={errorId}>
					{error}
				</span>
			)}
		</InputLabeledWrapper>
	)
}

export default InputLabeled
